import React, { useState, useEffect, useRef } from 'react'
import Layouts from '../layout/layouts'
import '../css/portfolioaddDetails.css'
import Select from 'react-select';
import portfolioService from '../../../services/portfolioService';
import technologyService from '../../../services/technologyService'
import portfolioDetailService from '../../../services/portfolioDetailService';
import Swal from 'sweetalert2';
import { Link, useNavigate, useParams } from 'react-router-dom';
import XError from '../../common/xError';
import DOMPurify from 'dompurify';
import ExtraDetails from './ExtraDetails';
import ImageCropperModal from './ImageCropperModal';

const PortfolioaddDetails = () => {
  const [portfolio, setPortfolio] = useState([]);
  const token = localStorage.getItem('token')
  const [isLoading, setIsLoading] = useState(false);
  const [technology, setTechnology] = useState([]);
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const ref = useRef();
  const [selectedDetailImage, setSelectedDetailImage] = useState(null);
  const detailRef = useRef();
  const [images, setImages] = useState([]);
  const { id } = useParams();
  const [multiimages, setMultiimages] = useState([]);
  const [inputFields, setInputFields] = useState([{
    options: '',
    link: ''
  }]);
  const fileInputRef = useRef(null);
  const mainImageFileTypeRef = useRef(null);
  const detailImageFileTypeRef = useRef(null);

  const defaultExtraDetails = {
    timeline: '',
    technologies: '',
    platforms: '',
    quote: '',
    architecture: '',
    architectingSolution: [
      { title: '', description: '', points: ['', ''] },
      { title: '', description: '', points: ['', ''] }
    ],
    keyChallenges: [{ title: '', description: '' }, { title: '', description: '' }],
    intelligentSolutions: [{ title: '', description: '' }, { title: '', description: '' }],
    aiAdvantages: [
      { title: '', description: '', stats: '' },
      { title: '', description: '', stats: '' },
      { title: '', description: '', stats: '' }
    ],
    measurableImpact: {
      description: '',
      userSatisfactionLabel: 'USER SATISFACTION',
      userSatisfaction: '',
      activeDownloadsLabel: 'ACTIVE DOWNLOADS',
      activeDownloads: '',
      increaseInConversionLabel: 'INCREASE IN CONVERSION',
      increaseInConversion: '',
      reductionInBounceRateLabel: 'REDUCTION IN BOUNCE RATE',
      reductionInBounceRate: '',
      fasterCheckoutSpeedLabel: 'FASTER CHECKOUT SPEED',
      fasterCheckoutSpeed: ''
    },
    startupAdvantages: [
      { heading: '', title: '', description: '' },
      { heading: '', title: '', description: '' },
      { heading: '', title: '', description: '' }
    ],
    startupChallenges: [{ title: '', description: '', stats: '' }],
    startupSolutions: [{ title: '', description: '', stats: '' }],
    enableAiAdvantage: false,
    enableMeasurableImpact: false,
    startupAiAdvantages: [
      { title: '', description: '' },
      { title: '', description: '' },
      { title: '', description: '' }
    ],
    industry: '',
    customKeyResults: {
      percentage: '', percentageDesc: '',
      downtime: '', downtimeDesc: '',
      historical: '', historicalDesc: ''
    },
    customChallenges: ['', '', ''],
    customSolutions: ['', '', ''],
    customAiAdvantages: [
      { title: '', points: ['', ''], stats: '' },
      { title: '', points: ['', ''], stats: '' },
      { title: '', points: ['', ''], stats: '' }
    ]
  };
  const [extraDetails, setExtraDetails] = useState(defaultExtraDetails);
  const [isMobileCategory, setIsMobileCategory] = useState(false);
  const [isUiUxCategory, setIsUiUxCategory] = useState(false);
  const [isStartupCategory, setIsStartupCategory] = useState(false);
  const [isCustomCategory, setIsCustomCategory] = useState(false);
  const [isMultipleCategory, setIsMultipleCategory] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [currentCropCategoryIsMobile, setCurrentCropCategoryIsMobile] = useState(false);
  const [currentCropCategoryName, setCurrentCropCategoryName] = useState(null);
  const [imageCategories, setImageCategories] = useState([]);
  const [extraImages, setExtraImages] = useState([]);
  const [architectingImages, setArchitectingImages] = useState([]);

  const [multiCropQueue, setMultiCropQueue] = useState([]);
  const [currentMultiCrop, setCurrentMultiCrop] = useState(null);

  const [showMainCropper, setShowMainCropper] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [mainImageToCrop, setMainImageToCrop] = useState(null);

  const [showDetailCropper, setShowDetailCropper] = useState(false);
  const [detailImageToCrop, setDetailImageToCrop] = useState(null);

  // const handleClick = () =>{
  //     setView(!view);
  // };
  useEffect(() => {
    portfolioDetailsList();
    TechnologyList();
    checkCategory();
  }, [])

  const checkCategory = async () => {
    try {
      const res = await portfolioService.detailPortfolio(token, id);
      if (res.data?.result?.length > 0) {
        const categories = res.data.result[0].categories || [];
        setSelectedCategories(categories);
        const isMultiple = categories.length > 1;
        setIsMultipleCategory(isMultiple);
        setIsMobileCategory(!isMultiple && categories.some(c => c.id == 2 || (c.name && c.name.toLowerCase().includes('mobile'))));
        setIsUiUxCategory(!isMultiple && categories.length === 1 && categories[0].id == 5);
        setIsStartupCategory(!isMultiple && categories.some(c => c.id == 4 || (c.name && c.name.toLowerCase().includes('startup'))));
        setIsCustomCategory(!isMultiple && categories.some(c => c.id == 1 || c.id == 3 || (c.name && c.name.toLowerCase().includes('custom'))));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const [formData, setFormData] = useState({
    portfolioId: '',
    image: null,
    detailImage: null,
    shortDescription: '',
    aboutUs: '',
    completitionDetails: '',
    businessProblem: '',
    solution: '',
    technology: '',
    customerName: '',
    launchedYear: '',
    platform: '',
    domain: '',
    country: ''
  });

  const [errors, setError] = useState({
    image: '',
    detailImage: '',
    shortDescription: '',
    aboutUs: '',
    completitionDetails: '',
    businessProblem: '',
    solution: '',
    technology: '',
    customerName: '',
    launchedYear: '',
    platform: '',
    domain: '',
    country: '',
    aiAdvantage: '',
    multi: []
  });
  //   const handleClick2 = () => {
  //   setLinks([...links, <div className='row'>
  //     <div className="col-sm-6">
  //     <select class="form-select form-select-lg"  onChange={handleSelectOption}>
  //         <option selected className='select-option'>Link</option>
  //         <option value="1">Android</option> 
  //         <option value="2">IOS</option> 
  //         <option value="3">Web</option> 
  //         <option value="4">Others</option> 
  //     </select>
  //     </div>
  //     <div className="col-sm-6"><input name='image2' className='form-control mb-2' type="text" /></div>

  //      </div> ]);
  // };  


  // const handleDelete = (index) => {
  //    setLinks(links.filter((link, i) => i !== index));
  //   console.log(index);
  //  };

  const portfolioDetailsList = async () => {

    await portfolioService.getPortfolio(token).then(res => {
      const options = res.data?.result.map(d => ({
        "id": d.id,
        "name": d.title

      }))
      setPortfolio(options)
    })
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file && allowedFile(file.name)) {
      mainImageFileTypeRef.current = file.type;
      setMainImageToCrop(URL.createObjectURL(file));
      setShowMainCropper(true);
    } else {
      setSelectedImage(null);
      setError({ ...errors, image: "Please select jpg,png and jpeg file" })
    }
  };

  const handleMainCropComplete = (croppedFile) => {
    setFormData({ ...formData, image: croppedFile });
    setSelectedImage(URL.createObjectURL(croppedFile));
    setShowMainCropper(false);
    setMainImageToCrop(null);
  };

  const handleMainCropCancel = () => {
    setShowMainCropper(false);
    setMainImageToCrop(null);
    if (ref.current) {
      ref.current.value = "";
    }
  };

  const handleDetailImageChange = (event) => {
    const file = event.target.files[0];

    if (file && allowedFile(file.name)) {
      detailImageFileTypeRef.current = file.type;
      setDetailImageToCrop(URL.createObjectURL(file));
      setShowDetailCropper(true);
    } else {
      setSelectedDetailImage(null);
      setError({ ...errors, detailImage: "Please select jpg,png and jpeg file" })
    }
  };

  const handleDetailCropComplete = (croppedFile) => {
    setFormData({ ...formData, detailImage: croppedFile });
    setSelectedDetailImage(URL.createObjectURL(croppedFile));
    setShowDetailCropper(false);
    setDetailImageToCrop(null);
  };

  const handleDetailCropCancel = () => {
    setShowDetailCropper(false);
    setDetailImageToCrop(null);
    if (detailRef.current) {
      detailRef.current.value = "";
    }
  };

  const allowedFile = (filename) => {
    const allowedExtensions = ['jpg', 'jpeg', 'png'];
    const extension = filename.split('.').pop().toLowerCase();
    return allowedExtensions.includes(extension);
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: DOMPurify.sanitize(value) }));
  };
  const onSubmit = async (event) => {
    setIsLoading(true)
    event.preventDefault();
    setIsSubmitted(true);
    if (checkValidation()) {
      const token = localStorage.getItem('token');
      const postData = new FormData();


      postData.append('portfolioId', id);
      postData.append('image', formData.image);
      if (formData.detailImage) {
        postData.append('detailImage', formData.detailImage);
      }
      postData.append('shortDescription', formData.shortDescription);
      postData.append('businessProblem', formData.businessProblem);
      postData.append('solution', formData.solution);
      postData.append('technology', formData.technology);
      postData.append('customerName', formData.customerName);
      postData.append('launchedYear', formData.launchedYear);
      postData.append('platform', formData.platform);
      postData.append('domain', formData.domain);
      postData.append('country', formData.country);
      postData.append('aboutUs', formData.aboutUs);
      postData.append('completitionDetails', formData.completitionDetails);

      inputFields.forEach((list, index) => {
        postData.append(`link`, list.link);
        postData.append(`options`, list.options);
      });
      images.forEach((img, index) => {
        postData.append(`images`, img);
      });

      if (imageCategories.length > 0) {
        postData.append('imageCategories', JSON.stringify(imageCategories));
      }

      postData.append('extraDetails', JSON.stringify(extraDetails));
      extraImages.forEach((img, index) => {
        postData.append(`extraImages`, img);
      });
      architectingImages.forEach((img, index) => {
        if (img) postData.append(`architectingImage_${index}`, img);
      });

      await portfolioDetailService.createPortfolioDetails(token, postData).then(async (res) => {

        setIsLoading(false)
        Swal.fire("Portfolio details added successfully.");
        navigate("/admin-portfolios")
      }).catch((err) => {
        setIsLoading(false)
        Swal.fire("Portfolio details not added.");
      })
    } else {
      setIsLoading(false)
    }

  };

  const checkValidation = () => {
    debugger;
    //  console.log("validation",state);
    let error = {
      image: null,
      detailImage: null,
      shortDescription: '',
      aboutUs: '',
      // completitionDetails:'',
      businessProblem: '',
      solution: '',
      technology: '',
      customerName: '',
      launchedYear: '',
      platform: '',
      multi: ''
    };

    const { shortDescription, aboutUs, completitionDetails, image, businessProblem, solution, technology, customerName, launchedYear, platform } = formData;

    let flag = true;

    if (shortDescription === "" || shortDescription === null || shortDescription === undefined || shortDescription.trim() === '') {
      error.shortDescription = "The short description field is required.";
      flag = false;
    }
    // if (completitionDetails === "" || completitionDetails === null || completitionDetails === undefined || completitionDetails.trim() === '') {
    //     error.completitionDetails = "The completition details field is required.";
    //     flag = false;
    //   }
    if (businessProblem === "" || businessProblem === null || businessProblem === undefined || businessProblem.trim() === '') {
      error.businessProblem = "The business problem field is required.";
      flag = false;
    }
    if (aboutUs === "" || aboutUs === null || aboutUs === undefined || aboutUs.trim() === '') {
      error.aboutUs = "The description field is required.";
      flag = false;
    }
    if (solution === "" || solution === null || solution === undefined || solution.trim() === '') {
      error.solution = "The solution field is required.";
      flag = false;
    }
    if (technology === "" || technology === null || technology === undefined || technology.trim() === '') {
      error.solution = "The technology field is required.";
      flag = false;
    }
    if (customerName === "" || customerName === null || customerName === undefined || customerName.trim() === '') {
      error.customerName = "The customer name field is required.";
      flag = false;
    }
    if (launchedYear === "" || launchedYear === null || launchedYear === undefined || launchedYear.trim() === '') {
      error.launchedYear = "The launched year field is required.";
      flag = false;
    } else {
      const isPositiveNumeric = /^[1-9]\d*$/.test(launchedYear);
      if (!isPositiveNumeric) {
        error.launchedYear = 'Value must be greater than zero';
        flag = false;
      }
    }
    if (platform === "" || platform === null || platform === undefined || platform.trim() === '') {
      error.platform = "The platform field is required.";
      flag = false;
    }

    if (isMobileCategory || isUiUxCategory || isMultipleCategory) {
      const kc = extraDetails?.keyChallenges || [];
      const len = isMultipleCategory ? 3 : (isUiUxCategory ? 2 : Math.min(3, Math.max(1, kc.length || 1)));
      if (kc.slice(0, len).some(item => !item.title?.trim() || !item.description?.trim())) {
        flag = false;
      }
    }
    if (isMobileCategory || isMultipleCategory) {
      const is = extraDetails?.intelligentSolutions || [];
      if (is.slice(0, 3).some(item => !item.title?.trim() || !item.description?.trim())) {
        flag = false;
      }
    }
    const isAiEnabled = extraDetails?.enableAiAdvantage === true || extraDetails?.enableAiAdvantage === 'true';
    if (isAiEnabled) {
      if (isMobileCategory || isUiUxCategory) {
        // if ((extraDetails?.aiAdvantages || []).slice(0, 3).some(item => !item.title?.trim() || !item.description?.trim())) flag = false;
      }
      if (isStartupCategory) {
        // if ((extraDetails?.startupAiAdvantages || []).slice(0, 3).some(item => !item.title?.trim() || !item.description?.trim())) flag = false;
      }
      if (isCustomCategory || isMultipleCategory) {
        // if ((extraDetails?.customAiAdvantages || []).slice(0, 3).some(item => !item.title?.trim() || !item.description?.trim())) flag = false;
        // if ((extraDetails?.customAiAdvantages || []).slice(0, 3).some(item => !item.title?.trim() || item.points.length <= 0)) { flag = false; error.aiAdvantage = 'Invalid AI-Driven Advantage'; }
      }
    }
    // Images are optional as per user request
    setError({ ...error });
    return flag;
  };

  const onReset = () => {
    setFormData({
      portfolioId: '',
      image: null,
      detailImage: null,
      shortDescription: '',
      aboutUs: '',
      completitionDetails: '',
      businessProblem: '',
      solution: '',
      technology: '',
      customerName: '',
      launchedYear: '',
      platform: [],
      domain: '',
      country: ''
    });
    setSelectedImage(null)
    setMultiimages([])
    ref.current.value = '';
    fileInputRef.current.value = '';
    setExtraDetails(defaultExtraDetails);
    setExtraImages([]);
    setArchitectingImages([]);
    setSelectedDetailImage(null);
    if (detailRef.current) detailRef.current.value = '';
    setError({
      image: '',
      detailImage: '',
      shortDescription: '',
      aboutUs: '',
      completitionDetails: '',
      businessProblem: '',
      solution: '',
      technology: '',
      customerName: '',
      launchedYear: '',
      platform: '',
      domain: '',
      country: '',
      multi: []
    });
  }
  const TechnologyList = async () => {
    await technologyService.getTechnology(token).then(res => {
      const options = res.data?.result.map(d => ({
        "id": d.id,
        "name": d.name

      }))
      setTechnology(options)
    })
  }


  const handleImageChangeMulti = async (e, isMobileCat = false, catName = null) => {
    const selectedImages = Array.from(e.target.files);
    const allowedExtensions = ['jpg', 'jpeg', 'png'];
    const validImages = selectedImages.filter(image =>
      allowedExtensions.some(ext =>
        image.name.toLowerCase().endsWith(ext)
      )
    );

    if (validImages.length === 0) {
      setError({ ...errors, multi: "Please select jpg,png and jpeg file" })
    } else {
      setError({ ...errors, multi: "" });
      setMultiCropQueue(validImages);
      setCurrentMultiCrop(URL.createObjectURL(validImages[0]));
      setCurrentCropCategoryIsMobile(isMobileCat);
      setCurrentCropCategoryName(catName);
    }

    e.target.value = '';
  }

  const handleMultiCropComplete = (croppedFile) => {
    setImages(prev => [...prev, croppedFile]);
    setMultiimages(prev => [...prev, URL.createObjectURL(croppedFile)]);
    if (isMultipleCategory && currentCropCategoryName) {
      setImageCategories(prev => [...prev, currentCropCategoryName]);
    } else {
      setImageCategories(prev => [...prev, null]);
    }

    const nextQueue = multiCropQueue.slice(1);
    setMultiCropQueue(nextQueue);
    if (nextQueue.length > 0) {
      setCurrentMultiCrop(URL.createObjectURL(nextQueue[0]));
    } else {
      setCurrentMultiCrop(null);
    }
  };

  const handleMultiCropCancel = () => {
    const nextQueue = multiCropQueue.slice(1);
    setMultiCropQueue(nextQueue);
    if (nextQueue.length > 0) {
      setCurrentMultiCrop(URL.createObjectURL(nextQueue[0]));
    } else {
      setCurrentMultiCrop(null);
    }
  };

  // const handleSelect = (data) =>{

  //   setFormData({ ...formData, portfolioId: data.value})
  // } 

  // const handleSelectOption = (e) =>{
  //   console.log(e) 
  //   // newFields = [...linkoption];
  //   // newFields[index] = event.target.value;
  //   //setLinkoption(newFields);
  // } 


  const handleSelectPlatform = (data) => {
    setFormData({ ...formData, platform: data.value })
  }



  const addInputField = () => {
    setInputFields([...inputFields, {
      options: '',
      link: ''
    }])

  }
  const removeInputFields = (index) => {
    //console.log(index)
    //index = index -1
    const rows = [...inputFields];
    rows.splice(index, 1);
    setInputFields(rows);
  }
  const handleChange2 = (index, evnt) => {
    const { name, value } = evnt.target;
    const list = [...inputFields];
    list[index][name] = value;
    setInputFields(list);



  }

  return (
    <>
      <Layouts>
        {showMainCropper && mainImageToCrop && (
          <ImageCropperModal
            imageSrc={mainImageToCrop}
            fileType={mainImageFileTypeRef.current}
            onCropComplete={handleMainCropComplete}
            onCancel={handleMainCropCancel}
            cropWidth={505}
            cropHeight={250}
          />
        )}
        {showDetailCropper && detailImageToCrop && (
          <ImageCropperModal
            imageSrc={detailImageToCrop}
            fileType={detailImageFileTypeRef.current}
            onCropComplete={handleDetailCropComplete}
            onCancel={handleDetailCropCancel}
            cropWidth={isMobileCategory ? 500 : 1150}
            cropHeight={isMobileCategory ? 400 : 600}
          />
        )}
        <div className='add-portfolioDetails'>
          <div className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12s">
                  <Link to="/admin-portfolios" className='add-link-color'>
                    <h4 className="dash-title">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M4.78645 10.7139L13.7804 19.7048C14.175 20.0984 14.8144 20.0984 15.21 19.7048C15.6047 19.3111 15.6047 18.6717 15.21 18.2781L6.92952 10.0005L15.209 1.72302C15.6037 1.32937 15.6037 0.689976 15.209 0.295329C14.8144 -0.098321 14.174 -0.098321 13.7794 0.295329L4.78545 9.28616C4.39687 9.67575 4.39687 10.3252 4.78645 10.7139Z" fill="#1F4168" />
                      </svg>
                      <span className='ps-3'>Add Portfolio Details</span>
                    </h4>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className='add-portfolio-body'>
            <div className="container-fluid">
              <div className='row'>
                <div className='col-12'>
                  <div className='card add-portfolio-card'>
                    <form className='card-body' onSubmit={onSubmit} noValidate>
                      <div className="slectd-image pb-4 d-flex align-items-start gap-4">
                        {selectedImage && (
                          <div>
                            <div className="text-muted small mb-2">Main Image Preview:</div>
                            <div className="custom-image-list">
                              <img src={selectedImage} alt="Selected" style={{ objectFit: 'contain' }} />{" "}
                            </div>
                          </div>
                        )}

                        {(isMobileCategory || isUiUxCategory) && selectedDetailImage && (
                          <div>
                            <div className="text-muted small mb-2">Detail Image Preview:</div>
                            <div className="custom-image-list">
                              <img src={selectedDetailImage} alt="Selected" style={{ objectFit: 'contain' }} />{" "}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='row'>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label className="form-label">Main Image (505x250)</label>
                            <input type="file" name='image' className="form-control hint" accept="image/*" ref={ref} onChange={handleImageChange} />
                            <XError message={errors.image} />
                          </div>
                        </div>

                        {(isMobileCategory || isUiUxCategory) && (
                          <div className='col-sm-6'>
                            <div className="mb-4">
                              <label className="form-label">Detail Image ({isMobileCategory ? '500x400' : '1150x600'})</label>
                              <input type="file" name='detailImage' className="form-control hint" accept="image/*" ref={detailRef} onChange={handleDetailImageChange} />
                              <XError message={errors.detailImage} />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='row'>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label for="exampleFormControlTextarea1" class="form-label">Project Short Description</label>
                            <textarea class="form-control" placeholder='Enter project short description' id="exampleFormControlTextarea1" rows="3" maxLength={300} name="shortDescription" onChange={handleChange} value={formData.shortDescription}></textarea>
                            <XError message={errors.shortDescription} />
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label for="exampleFormControlTextarea1" class="form-label">About an app</label>
                            <textarea class="form-control" placeholder='Enter about us' id="exampleFormControlTextarea1" rows="3" name="aboutUs" onChange={handleChange} value={formData.aboutUs} maxlength="1000"></textarea>
                            <XError message={errors.aboutUs} />
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label for="exampleFormControlTextarea1" class="form-label">How We Completed Details</label>
                            <textarea class="form-control" placeholder='Enter we completed details' id="exampleFormControlTextarea1" rows="3" name="completitionDetails" onChange={handleChange} value={formData.completitionDetails}></textarea>
                            <XError message={errors.completitionDetails} />
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label for="exampleFormControlTextarea1" class="form-label">Business Problem</label>
                            <textarea class="form-control" placeholder='Enter business detail' id="exampleFormControlTextarea1" rows="3" name="businessProblem" onChange={handleChange} value={formData.businessProblem}></textarea>
                            <XError message={errors.businessProblem} />
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label for="exampleFormControlTextarea1" class="form-label">The Solution</label>
                            <textarea class="form-control" placeholder='Enter solution details' id="exampleFormControlTextarea1" rows="3" name="solution" onChange={handleChange} value={formData.solution} maxlength="255"></textarea>
                            <XError message={errors.solution} />
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label for="exampleFormControlTextarea1" class="form-label">Technology</label>
                            <textarea class="form-control" placeholder='Enter technologies detail' id="exampleFormControlTextarea1" rows="3" name="technology" onChange={handleChange} value={formData.technology}></textarea>
                            <XError message={errors.technology} />
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label for="exampleFormControlTextarea1" class="form-label">Launched Year</label>
                            <input type="text" className="form-control" name="launchedYear"
                              value={formData.launchedYear}
                              onChange={(event) => {
                                const input = event.target.value;
                                const numericInput = input.replace(/[^\d.]/g, ''); // Remove all non-numeric characters
                                // Check if the input contains only numbers or not
                                const isNumeric = /^(\d*\.)?\d*$/.test(numericInput);
                                if (isNumeric) {
                                  setFormData({ ...formData, launchedYear: numericInput });
                                }
                              }}
                              placeholder="Enter experience" maxLength={4} readOnly={!/^(\d*\.)?\d*$/.test(formData.launchedYear)} />

                            {/* <textarea class="form-control" placeholder='Enter launch year' id="exampleFormControlTextarea1"
                      rows="1" name="launchedYear" onChange={handleChange}>{formData.launchedYear}</textarea> */}
                            <XError message={errors.launchedYear} />
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label for="exampleFormControlTextarea1" class="form-label">Customer Name</label>
                            <textarea class="form-control" placeholder='Enter customer name' id="exampleFormControlTextarea1" rows="1" name="customerName" onChange={handleChange} maxLength={20} value={formData.customerName}></textarea>
                            <XError message={errors.customerName} />
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label className="form-label">Platform</label>
                            <Select options={technology.map((tech) => ({ value: tech.id, label: tech.name }))}
                              placeholder="Select platform" className='custom-select' name="platform" onChange={handleSelectPlatform} />
                            <XError message={errors.platform} />
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label className="form-label">Domain</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter domain"
                              name="domain"
                              value={formData.domain}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className='col-sm-6'>
                          <div className="mb-4">
                            <label className="form-label">Country</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter country"
                              name="country"
                              value={formData.country}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div> {inputFields.map((data, index) => {
                        return (<div className="row m-b-5" key={index}>
                          <div className="col-md-6 ">
                            <div className="mb-2">
                              <label className="form-label">Select Option</label>
                              <select class="form-select form-select-lg" aria-label=".form-select-lg example" name="options" onChange={(evnt) => handleChange2(index, evnt)} placeholder='Select link'> <option value="" className='option-place' selected disabled>Link</option>
                                <option value="1">Android</option>
                                <option value="2">IOS</option>
                                <option value="3">Web</option>
                                <option value="4">Others</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6 ">
                            <div className="mb-2">
                              <label className="form-label">Link</label>
                              <input type="text" onChange={(evnt) => handleChange2(index, evnt)} name="link" className="form-control" placeholder="Enter link" />
                            </div>
                          </div>
                          <div className="col-md-12 col-cm-6"> {(inputFields.length !== 1) ? <p className="add-service-btn pt-2" id='del' onClick={(evnt) => removeInputFields(index, evnt)}>Delete</p> : ''} </div>
                        </div>)
                      })} <div className="row">
                        <div className="col-sm-12 text-right">
                          <p type="button" className="add-service-btn" onClick={addInputField}>Add New</p>
                        </div>
                      </div>
                      {/* <div className="row">
                 <div className="col-sm-6"></div>
                 <div className="col-sm-6">
                   <div>{view && <div className='img_box'></div>} </div>
                 </div>
               </div> */}
                      <div className='row'>
                        {isMultipleCategory ? (
                          <div className="col-12 mb-4">
                            <label className="form-label font-weight-bold" style={{ fontSize: '1.1rem' }}>Category-Specific Gallery Uploads</label>
                            <div className="row mt-2">
                              {(() => {
                                const hasMobile = selectedCategories.some(c => c.id == 2 || (c.name && c.name.toLowerCase().includes('mobile')));
                                const hasUiUx = selectedCategories.some(c => c.id == 5 || (c.name && c.name.toLowerCase().includes('ui/ux') || c.name.toLowerCase().includes('ui ux')));
                                const hasWeb = selectedCategories.some(c => !((c.id == 2 || (c.name && c.name.toLowerCase().includes('mobile'))) || (c.id == 5 || (c.name && c.name.toLowerCase().includes('ui/ux') || c.name.toLowerCase().includes('ui ux')))));

                                let galleryOptions = [];
                                if (hasWeb) galleryOptions.push({ name: 'Web', isMob: false });
                                if (hasMobile) galleryOptions.push({ name: 'Mobile', isMob: true });
                                if (hasUiUx) galleryOptions.push({ name: 'UI/UX Design', isMob: false });

                                return galleryOptions.map((opt, idx) => (
                                  <div className='col-sm-4' key={idx}>
                                    <div className="p-3 border rounded shadow-sm bg-light mb-3 h-100">
                                      <div className="d-flex align-items-center mb-2">
                                        <h6 className="mb-0 text-primary fw-bold" style={{ fontSize: '0.95rem' }}>{opt.name} Images</h6>
                                      </div>
                                      <p className="text-muted small mb-3" style={{ fontSize: '0.8rem', lineHeight: '1.4' }}>
                                        Upload images for the <strong>{opt.name}</strong> platform.
                                        <br />
                                        <span className="badge bg-secondary mt-1">Crop: {opt.isMob ? '305 x 660' : '1090 x 520'}</span>
                                      </p>
                                      <input className="form-control form-control-sm" type="file" multiple accept=".jpg, .jpeg, .png" onChange={(e) => handleImageChangeMulti(e, opt.isMob, opt.name)} />
                                    </div>
                                  </div>
                                ));
                              })()}
                            </div>
                          </div>
                        ) : (
                          <div className='col-sm-6'>
                            <div className="mb-4">
                              <label className="form-label ">Select Multiple Images</label>
                              <input className="form-control" type="file" multiple accept=".jpg, .jpeg, .png" onChange={(e) => handleImageChangeMulti(e, isMobileCategory, null)} />
                              <XError message={errors.multi} />
                            </div>
                          </div>
                        )}
                      </div>

                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', marginBottom: '15px' }}>
                        {(multiimages != null) ? multiimages.map((url, i) => {
                          return (
                            <div key={i} style={{ width: '200px' }}>
                              <div className="position-relative rounded overflow-hidden shadow-sm border bg-light" style={{ aspectRatio: '4/3' }}>
                                <img src={url} alt="Selected" className="w-100 h-100" style={{ objectFit: 'cover' }} />
                                {isMultipleCategory && imageCategories[i] && (
                                  <span className="badge bg-primary position-absolute bottom-0 start-0 m-2 shadow-sm">{imageCategories[i]}</span>
                                )}
                                <button type="button" className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2 rounded-circle shadow d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} onClick={() => {
                                  setImages(images.filter((_, idx) => idx !== i));
                                  setMultiimages(multiimages.filter((_, idx) => idx !== i));
                                  setImageCategories(prev => prev.filter((_, idx) => idx !== i));
                                }} title="Remove image">
                                  <span style={{ fontSize: '18px', fontWeight: 'bold', lineHeight: 1, marginTop: '-2px' }}>&times;</span>
                                </button>
                              </div>
                            </div>
                          )
                        }) : ''}
                      </div>

                      {currentMultiCrop && (
                        <ImageCropperModal
                          imageSrc={currentMultiCrop}
                          fileType={multiCropQueue[0]?.type}
                          cropWidth={(isMobileCategory || currentCropCategoryIsMobile) ? 305 : 1090}
                          cropHeight={(isMobileCategory || currentCropCategoryIsMobile) ? 660 : 520}
                          onCropComplete={handleMultiCropComplete}
                          onCancel={handleMultiCropCancel}
                        />
                      )}

                      <ExtraDetails
                        extraDetails={extraDetails}
                        setExtraDetails={setExtraDetails}
                        isMobileCategory={isMobileCategory}
                        isUiUxCategory={isUiUxCategory}
                        isStartupCategory={isStartupCategory}
                        isCustomCategory={isCustomCategory}
                        isMultipleCategory={isMultipleCategory}
                        extraImages={extraImages}
                        setExtraImages={setExtraImages}
                        architectingImages={architectingImages}
                        setArchitectingImages={setArchitectingImages}
                        isSubmitted={isSubmitted}
                      />

                      <div className='col-md-12'>
                        <XError message={errors.aiAdvantage} />
                      </div>

                      <div className='footer-button pt-2'>

                        <button type='button' onClick={onReset} className='cancel-button'>Cancel</button> {isLoading ? (<button type='submit' className='submit-button'>Loading...</button>) : (<button type='submit' className='submit-button'>Submit</button>)}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layouts>
    </>
  )
}

export default PortfolioaddDetails;
